import { createTheme, ThemeProvider } from '@mui/material/styles';
import React, { useEffect } from 'react';
// import Header from 'components/header';
import 'styles/custom.scss';
// import Layout from 'components/layout';
import { useLocation, useNavigate } from 'react-router-dom';
import { useSetRecoilState } from 'recoil';
import Router from 'routes';
import { detailsAtom, meetingDetailsAtom, meetingStylesAtom, stylesAtom } from '_state/signature';

const mdTheme = createTheme({
  palette: {
    secondary: {
      main: '#FF8140',
      contrastText: '#fff',
    },
    info: {
      main: '#F7F7F7',
    },
  },
});

const App: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const setDetails = useSetRecoilState(detailsAtom);
  const setMeetingDetails = useSetRecoilState(meetingDetailsAtom);
  const setSignatureStyles = useSetRecoilState(stylesAtom);
  const setMeetingStyles = useSetRecoilState(meetingStylesAtom);

  useEffect(() => {
    if (!['/', '/email-signature', '/v-card'].includes(location.pathname))
      navigate('/', { replace: true });

    //set initial details from local storage
    if (localStorage.getItem('signatureDetails'))
      setDetails(JSON.parse(localStorage.getItem('signatureDetails')!));
    if (localStorage.getItem('meetingDetails')) {
      const { personalInfo, ...meetingDetails } = JSON.parse(
        localStorage.getItem('meetingDetails')!,
      ); // remove logo key since it will be empty
      if (personalInfo)
        setMeetingDetails({ ...meetingDetails, personalInfo: { ...personalInfo, logo: '' } });
    }
    if (localStorage.getItem('signatureStyles'))
      setSignatureStyles(JSON.parse(localStorage.getItem('signatureStyles')!));
    if (localStorage.getItem('meetingStyles'))
      setMeetingStyles(JSON.parse(localStorage.getItem('meetingStyles')!));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <ThemeProvider theme={mdTheme}>
      <div className="App">
        <Router />
        {/* <Header /> */}
        {/* <Layout /> */}
      </div>
    </ThemeProvider>
  );
};

export default App;
